export const ROUTE = {
    TAXINVOICE:"/tax-invoice",
    TAXINVOICE_SELECT:"/tax-invoice-select",
    TAXINVOICE_EDIT:"/tax-invoice-edit",
    TAXINVOICE_SAVEDATA:"/tax-invoice-savedata",
    TAXINVOICE_PREVIEW:"/tax-invoice-preview",
    TAXINVOICE_SEARCH_ABB:"/tax-invoice-search-buy",

    REPLACE_SELECT:"/replace-select-taxinvoice",
    REPLACE_PREVIEW:"/replace-preview",
}